export const signet = [
  '102 115',
  `    <g style="fill:currentColor;">
  <g transform="matrix(1 0 0 1 0 0)" class="icon1"><path d="M83.333,10H16.667C13.001,10,10,13.001,10,16.667v66.666C10,86.999,13.001,90,16.667,90h66.666  C86.999,90,90,86.999,90,83.333V16.667C90,13.001,86.999,10,83.333,10z M80,66.667L50,83.333l-16.667-9.258V41.179L50,31.921  l16.667,9.258v17.643L50,68.079l-3.333-1.852V49.023L50,47.175l3.333,1.849v9.577L60,54.899v-9.799l-10-5.557l-10,5.557v25.049  l10,5.557l23.333-12.962V37.256L50,24.294L26.667,37.256v33.115L20,66.667V33.333l30-16.666l30,16.666V66.667z"></path></g>

    </g>`,
]

